import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
import { TranslatedString } from './TranslatedString.js';
import { upgradePriceFrom2To4DecimalPlaces } from './upgradePriceFrom2To4DecimalPlaces.js';
export class AppliedRegistrationDiscount extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Snapshot of the discount that was applied to this registration.
         * This contains the name of the discount and settings.
         */
        this.name = new TranslatedString('');
    }
}
__decorate([
    field(TranslatedString.field({}))
], AppliedRegistrationDiscount.prototype, "name", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], AppliedRegistrationDiscount.prototype, "amount", void 0);
//# sourceMappingURL=AppliedRegistrationDiscount.js.map